import { render, staticRenderFns } from "./AppliedMedication.vue?vue&type=template&id=1ac12bd9&"
import script from "./AppliedMedication.vue?vue&type=script&lang=js&"
export * from "./AppliedMedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports